'use client';

import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { parseVideoUrl } from '@/utils/video';

const VideoEmbedClient = ({ url, thumbnailUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const iframeRef = useRef(null);
  const playerUrl = parseVideoUrl(url)?.playerUrl;

  useEffect(() => {
    if (isPlaying) {
      iframeRef.current?.focus();
    }
  }, [isPlaying]);

  if (!playerUrl) return null;

  if (isPlaying) {
    // Safari workaround: drops unmuted autoplay after this click (confirmed on device).
    const separator = playerUrl.includes('?') ? '&' : '?';
    const autoplayUrl = `${playerUrl}${separator}autoplay=1&mute=1&playsinline=1`;

    return (
      <div className="relative aspect-video w-full overflow-hidden rounded-sm">
        <iframe
          ref={iframeRef}
          src={autoplayUrl}
          title="Video"
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-sm">
      {thumbnailUrl ? (
        <Image
          src={thumbnailUrl}
          alt="Video thumbnail"
          className="absolute inset-0 w-full h-full object-cover"
          fill
          sizes="(max-width: 896px) 100vw, 896px"
        />
      ) : (
        <div className="absolute inset-0 bg-gray-900" />
      )}

      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <button
          type="button"
          onClick={() => setIsPlaying(true)}
          className="pointer-events-auto cursor-pointer transition duration-300 hover:scale-110"
        >
          <span className="sr-only">Play video</span>
          <svg
            className="w-16 h-16 md:w-20 md:h-20"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            aria-hidden="true"
            viewBox="0 0 70 70"
          >
            <circle cx="35" cy="35" r="35" className="fill-sea"></circle>
            <path fill="#fff" d="M49 34.4 27.1 47V21.8L49 34.4z"></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default VideoEmbedClient;
